import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/config";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={waLink("Olá, Agro Carmo! Vim pelo site e quero fazer um pedido.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      initial={{ opacity: 0, scale: 0.6, y: 24 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 20 }}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] p-4 text-white shadow-2xl shadow-[#25D366]/40 transition-transform duration-300 hover:scale-110"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width,margin] duration-500 group-hover:ml-3 group-hover:max-w-[12rem]">
        Falar no WhatsApp
      </span>
    </motion.a>
  );
}
